'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-tree-editor.routes';

export class DocumentTreeEditorComponent {

  constructor($uibModal, SettingsService, dialogs, $scope, prompt, Config, $window) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;
    this.$scope = $scope;
    this.prompt = prompt;
    this.$window = $window;

    SettingsService.getByName({name: 'config.app'}, setting => {
      this.setting = setting;

      let rPrepare = (node) => {
        if (!node.children) {
          node.children = [];
        } else {
          node.children.forEach(child => rPrepare(child, node.id));
        }
      };
      
      this.documentTree = setting.data.moduleConfig.document.documentTree || [];
      this.documentTree.forEach(node => rPrepare(node));
    });

    this.remove = function (scope) {

      var nodeData = scope.$modelValue;

      var info = nodeData.children.length ? " and <strong>ALL its child nodes</strong>?" : "?";

      var dlg = this.dialogs.confirm("Delete Node?", "Do you really want to node <strong>"+nodeData.name+"</strong>" + info);
      dlg.result.then(() => {
        scope.remove();
      }, () => {
        // Cancel
      });
    };

    this.toggle = function (scope) {
      scope.toggle();
    };

    this.moveLastToTheBeginning = function () {
      var a = this.documentTree.pop();
      this.documentTree.splice(0, 0, a);
    };

    this.newItem = _ => {
      var that = this;

      var modalInstance = this.$uibModal.open({
        animation: true,
        size: 'md',
        component: 'documentTreeNodeEdit',
        resolve: {
          config: function() {
            return {

            }
          }
        }
      });

      modalInstance.result.then(
        function (newNode) {
          that.documentTree.push({
            id: newNode.id,
            name: newNode.name,
            children: []
          });
        },
        function () { /* cancel */ }
      );
    };

    this.newSubItem = function (scope) {
      var nodeData = scope.$modelValue;


      var that = this;

      var modalInstance = this.$uibModal.open({
        animation: true,
        size: 'md',
        component: 'documentTreeNodeEdit',
        resolve: {
          config: function() {
            return {

            }
          }
        }
      });

      modalInstance.result.then(
        function (newNode) {
          nodeData.children.push({
            id: newNode.id,
            name: newNode.name,
            children: []
          });
        },
        function () { /* cancel */ }
      );
    };

    this.collapseAll = function () {
      this.$scope.$broadcast('angular-ui-tree:collapse-all');
    };

    this.expandAll = function () {
      this.$scope.$broadcast('angular-ui-tree:expand-all');
    };

  }

  openNodeEditor(node) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'md',
      component: 'documentTreeNodeEdit',
      resolve: {
        config: function() {
          return {
            node
          }
        }
      }
    });

    modalInstance.result.then(
      function (newNode) {
        node.id = newNode.id;
        node.name = newNode.name;
      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data.moduleConfig.document.documentTree = this.documentTree;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The document tree has been updated successfully");
      //then:  this.$window.location.reload();
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.documentTreeEditor', [uiRouter])
  .config(routes)
  .component('documentTreeEditor', {
    template: require('./document-tree-editor.html'),
    controller: DocumentTreeEditorComponent,
    controllerAs: 'ctrl',
    bindings: {}
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/document-tree/document-tree-editor.component.js